// Sidebar akun Karyawan (role 4): Employee Self Service
export default [
  {
    component: 'CNavTitle',
    name: 'Employee Self Service',
  },
  {
    component: 'CNavItem',
    name: 'Beranda',
    to: '/ess/beranda',
    icon: 'cil-home',
  },
  {
    component: 'CNavItem',
    name: 'Presensi',
    to: '/ess/presensi',
    icon: 'cil-clock',
  },
  {
    component: 'CNavItem',
    name: 'Profil Saya',
    to: '/ess/profil',
    icon: 'cil-user',
  },
  {
    component: 'CNavItem',
    name: 'Payslip Saya',
    to: '/ess/payslip',
    icon: 'cil-description',
  },
  {
    component: 'CNavItem',
    name: 'Kartu Nama Saya',
    to: '/ess/kartu-nama',
    icon: 'cil-contact',
  },
  {
    component: 'CNavItem',
    name: 'Cuti & Izin',
    to: '/ess/cuti',
    icon: 'cil-calendar',
  },
  {
    component: 'CNavItem',
    name: 'Persetujuan Tim',
    to: '/ess/tim',
    icon: 'cil-user-follow',
  },
]
